export const getDateIn10Days = () => {
  const currentDate = new Date()
  const in10DaysDate = new Date(
    currentDate.getTime() + 10 * 24 * 60 * 60 * 1000,
  )
  return in10DaysDate.toISOString()
}
